/**
 * WordPress dependencies
 */
import { createSlotFill } from '@wordpress/components';

const EditorContentSlotFill = createSlotFill(
	Symbol( 'EditCanvasContainerSlot' )
);

export default EditorContentSlotFill;
